import {
    PressReleaseListFilter,
    GetPressReleaseListItemsRequest,
    GetPressReleaseSingleItemRequest,
} from '@finance-lab/utils/types'
import ApiBase from './Api'

export class PressReleaseApi extends ApiBase {
    allPressReleases(
        paginationModel: {
            page: number
            pageSize: number
        },
        filter: PressReleaseListFilter,
    ) {
        return this._getRequest<GetPressReleaseListItemsRequest>('/press-releases', {
            queryParameters: { ...filter, limit: paginationModel.pageSize, page: paginationModel.page },
        })
    }

    findById(id: string) {
        return this._getRequest<GetPressReleaseSingleItemRequest>(`/press-releases/${id}`)
    }
}
